import { FLOW_STEPS } from '../constants';

export const getInitialActivationStep = (params?: string) => {
  const { ENROLL, ENTER_DETAILS } = FLOW_STEPS;
  if (params) {
    const fromTracker = params === 'true';
    return fromTracker ? ENTER_DETAILS : ENROLL;
  }
  return ENROLL;
};

export const makeStepBack = (params: string, cbWithParams: () => void, cbWithOutParams: () => void) => {
  if (params) {
    const fromTracker = params === 'true';
    if (fromTracker) {
      cbWithParams();
    } else cbWithOutParams();
  } else cbWithOutParams();
};
